import React from "react";
import RhfController from "./components/RhfController";

const ReactHookFormGenerator = ({ control, formState, DataArray }) => {
  // data array eg..
  // {
  //   element: (
  //     <CustomizableSelect
  //       SelectableDataArray={bankAccountData}
  //       label={languageElements[0]}
  //       isSingle={true}
  //       editable={SelectedElement}
  //       value={ArabicToPersian(SelectedElement?.NameBank)}
  //     />
  //   ),
  //   name: "idBank",
  //   required: true,
  // },
  // {
  //   element: !SelectedElement ? (
  //     <PersianSupportNumericTextField label={languageElements[1]} />
  //   ) : (
  //     <EditablePersianSupportNumericTextField
  //       value={SelectedElement.FldShomareCart}
  //       label={languageElements[1]}
  //     />
  //   ),
  //   name: "shomareCart",
  //   required: true,
  // },
  // {
  //   element: !SelectedElement ? (
  //     <PersianSupportNumericTextField label={languageElements[2]} />
  //   ) : (
  //     <EditablePersianSupportNumericTextField
  //       value={SelectedElement.FldHesabNo}
  //       label={languageElements[2]}
  //     />
  //   ),
  //   name: "hesabNo",
  //   required: true,
  // },

  return (
    <React.Fragment>
      {DataArray?.map((el, index) =>
        el.name ? (
          <RhfController
            control={control}
            element={el.element}
            required={el.required}
            errors={formState.errors}
            name={el.name}
            key={index}
            ispassword={el.isPassword}
          />
        ) : (
          <React.Fragment key={index}>{el.element}</React.Fragment>
        )
      )}
    </React.Fragment>
  );
};

export default ReactHookFormGenerator;
